import { render, staticRenderFns } from "./titleDetailInfoRow.vue?vue&type=template&id=2375d225&scoped=true"
import script from "./titleDetailInfoRow.vue?vue&type=script&setup=true&lang=ts"
export * from "./titleDetailInfoRow.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./titleDetailInfoRow.vue?vue&type=style&index=0&id=2375d225&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2375d225",
  null
  
)

export default component.exports